import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {TwoFactor} from './components/TwoFactor'
import {Login} from './components/Login'
import {NewPassword} from './components/NewPassword'
import {AuthLayout} from './AuthLayout'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='recovery/:id' element={<NewPassword />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='2fa' element={<TwoFactor />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
